module.exports = __webpack_public_path__ + "img/mw.5842e772.svg";